function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C_183",
  "data-name": "\\u0421\\u0433\\u0440\\u0443\\u043F\\u043F\\u0438\\u0440\\u043E\\u0432\\u0430\\u0442\\u044C 183",
  transform: "translate(-267.088 -139.125)"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_2",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 2",
  d: "M69.881,15.81H7.343A2.851,2.851,0,0,1,4.5,12.968h0a2.851,2.851,0,0,1,2.843-2.843H69.881a2.851,2.851,0,0,1,2.843,2.843h0A2.851,2.851,0,0,1,69.881,15.81Z",
  transform: "translate(262.588 129)",
  fill: "#313136"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_3",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 3",
  d: "M69.881,22.56H7.343A2.851,2.851,0,0,1,4.5,19.718h0a2.851,2.851,0,0,1,2.843-2.843H69.881a2.851,2.851,0,0,1,2.843,2.843h0A2.851,2.851,0,0,1,69.881,22.56Z",
  transform: "translate(262.588 139.307)",
  fill: "#313136"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440_4",
  "data-name": "\\u041A\\u043E\\u043D\\u0442\\u0443\\u0440 4",
  d: "M69.881,29.31H7.343A2.851,2.851,0,0,1,4.5,26.468h0a2.851,2.851,0,0,1,2.843-2.843H69.881a2.851,2.851,0,0,1,2.843,2.843h0A2.851,2.851,0,0,1,69.881,29.31Z",
  transform: "translate(262.588 149.611)",
  fill: "#313136"
}));

var SvgMenuMobale = function SvgMenuMobale(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 68.223 39.797",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMenuMobale, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/menuMobale.e126b6b1.svg";
export { ForwardRef as ReactComponent };